/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { useErrorBoundary } from 'preact/hooks';

// Core
import RouterComponent from '@client/services/router/components/router';
import { Button, Popover, Link, Input } from '@client/components';

// App
import Analytics from '@/client/services/metrics/Component';
import Loader from './Loader';

// Resources
import './index.less';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- LAYOUT
----------------------------------*/

// TODO: Route.layout()
// TODO: route.config.bodyClass
export const data = ({ api }) => ({
    //stats: api.get('/stats/general'),
    navigation: api.get('/ui/navigation'),
})

export default ({ data, user, api, Router, toast, modal, context, app, request, page }) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    // Render bug report
    // TIDO: move to framework
    useErrorBoundary(e => {
        app.reportBug({
            before: 'Render page',
            stacktrace: e.stack
        }).then(() => {

            // Reload page
            if (__DEV__) {
                console.warn(`The app would be reloaded in production mode.`);
                toast.error(`Errur during page rendering: ${e.message}`);
                console.error(e);
            } else 
                toast.error(`An issue occurred while loading this page. Our dev team will solve it asap.`);
        })
    });

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return <>

        <Analytics />

        <div id="layout" class="landing col al-center al-top">

            <div id="contPage" class="col">

                <RouterComponent service={Router} loaderComponent={Loader} />

            </div>
        </div>
    </>
}